// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Card$Showside from "./Card.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function PlaceholderCard(Props) {
  var title = Props.title;
  var showTitleOpt = Props.showTitle;
  var shape = Props.shape;
  var renderAfterTitle = Props.renderAfterTitle;
  var kind = Props.kind;
  var dataTestId = Props.dataTestId;
  var contentBoxStylableClassName = Props.contentBoxStylableClassName;
  var titleStylableClassName = Props.titleStylableClassName;
  var children = Props.children;
  var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
  var match = ConfigurationProvider$Showside.use(undefined);
  var settings = match.config.settings;
  var randId = React.useRef(Math.random().toString()).current;
  var shape$1 = kind || !(typeof shape === "number" && (shape > 3 || shape < 1)) ? shape : settings.productCardShape;
  var lineClamp = kind ? settings.categoryCardTitleLineTruncate : settings.productCardTitleLineTruncate + 1 | 0;
  var backgroundCn = "bg-placeholder";
  var renderTitle = function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex mt-4 flex-col space-y-4", shape$1 === /* Circle */0 ? "items-center" : "items-start"]))
    }, Belt_Array.makeBy(lineClamp, function (i) {
      return React.createElement("div", {
        key: String(i),
        className: CSS$Showside.prefix(Cn.make(["h-6 rounded", i === (lineClamp - 1 | 0) ? "w-4/5" : "w-full", backgroundCn])),
        data: String(i)
      });
    }));
  };
  var tmp = {
    shape: shape$1,
    id: randId,
    lineClamp: 1,
    showTitle: showTitle,
    contentBoxStylableClassName: contentBoxStylableClassName,
    titleStylableClassName: titleStylableClassName,
    imageSize: [undefined, undefined],
    renderTitle: renderTitle,
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["h-full w-full", backgroundCn]))
    }, Belt_Option.getWithDefault(children, null))
  };
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  if (dataTestId !== undefined) {
    tmp.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (renderAfterTitle !== undefined) {
    tmp.renderAfterTitle = Caml_option.valFromOption(renderAfterTitle);
  }
  return React.createElement(Card$Showside.make, tmp);
}
PlaceholderCard.displayName = "PlaceholderCard";
var make = PlaceholderCard;
export { make };
/* react Not a pure module */